import React from 'react';
import { useBonusContext } from '../../../contexts/BonusContext';

export const useRewards = () => {
	const { draftstarsRewards, wageringRewards, activeBrand } = useBonusContext();

	const boostUpBonusList = React.useMemo(() => {
		return wageringRewards.filter((item) => item.type === 'boosts' && (item.attributes.active_count ?? 0) > 0);
	}, [wageringRewards]);

	const ticketList = React.useMemo(() => {
		return draftstarsRewards.filter((item) => item.type === 'bonuses');
	}, [draftstarsRewards]);

	const promotionsBonusList = React.useMemo(() => {
		if (activeBrand === 'Betting') {
			return wageringRewards.filter((item) => item.type === 'promotions');
		} else {
			return draftstarsRewards.filter((item) => item.type === 'promotions');
		}
	}, [activeBrand, wageringRewards, draftstarsRewards]);

	const wageringRewardCounts = React.useMemo(() => {
		let activeCounts = wageringRewards.reduce((acc, item) => {
			return (acc += item.attributes.active_count ?? 0);
		}, 0);
		return activeCounts + wageringRewards.filter((item) => item.type === 'promotions').length;
	}, [wageringRewards]);
	const isNoRewards = React.useMemo(() => {
		if (activeBrand === 'Betting' && promotionsBonusList.length === 0 && boostUpBonusList.length === 0) {
			return true;
		} else if (activeBrand === 'Fantasy' && ticketList.length === 0 && promotionsBonusList.length === 0) {
			return true;
		}
		return false;
	}, [activeBrand, boostUpBonusList.length, promotionsBonusList.length, ticketList.length]);
	return {
		boostUpBonusList,
		ticketList,
		promotionsBonusList,
		wageringRewardCounts,
		isNoRewards,
	};
};
